var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"error","disabled":"","icon":""}},[_c('v-icon',[_vm._v("mdi-bug")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }